import { css } from '@emotion/core'
import { colors, measures, spacing, font } from 'styles/variables'

const { unit, half } = measures

export const menu = css`
  list-style: none;
  margin-right: ${2 * unit}px;

  height: 100%;
`

export const link = css`
  display: flex;

  align-items: center;
  height: ${spacing(5)};

  white-space: nowrap;
  text-decoration: none;
  color: ${colors.white100};

  > span {
    width: ${spacing(0.75)};
    margin-right: ${unit * 4}px;
    height: 100%;
  }

  & > div > span {
    font-weight: ${font.weight.medium};
  }

  :hover {
    color: ${colors.greens.green6};
    & > div > span {
      color: ${colors.greens.green6};
    }
  }
`

export const wrapperLinkContent = css`
  white-space: nowrap;
  margin-right: ${unit}px;
`
export const icon = css`
  color: ${colors.white100};
  margin-left: ${unit}px;
`

export const activeLink = css`
  color: ${colors.greens.green6};
  > span {
    background-color: ${colors.greens.green6};
    border-radius: ${spacing(0, 1.25, 1.25, 0)};
  }
  & > div > span {
    color: ${colors.greens.green6};
  }
  & > div > svg {
    color: ${colors.greens.green6};
  }
`

export const actionIcon = css`
  min-width: ${7 * half}px;
`
